// extracted by mini-css-extract-plugin
export var actionButton = "_kx-0";
export var fileInput = "_kx-2";
export var paperclip = "_kx-1";